// import 'element-plus/theme-chalk/index.css'
// import 'element-plus/dist/index.css'
import './assets/styles/element/index.scss'
import './assets/styles/main.scss'
import ElementPlus from 'element-plus'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import "./router/permission"

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.use(ElementPlus)
app.mount('#app')
